module.exports = __webpack_public_path__ + "static/img/3.d1b1c729.png";